/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useFetchList } from 'store'

import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { useEffect, useState } from 'react'
import Note from 'models/Note'
import useSession from 'hooks/useSession'
import NotesController from './PersonalAreaControllers/NotesController'
import RemindersController from './PersonalAreaControllers/RemindersController'
import ManagementOpinionController from './PersonalAreaControllers/ManagementOpinionController'
import { PersonalAreaContext } from './PersonalAreaContext'
import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'
import LastUpdate from 'components/general/LastUpdate/LastUpdate'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import styles from './PersonalAreaController.module.sass'
import MedicalOpinion from 'models/MedicalOpinion'
import { Task } from 'models'

const SelectedController = (selectedTab) => {
	switch (selectedTab) {
		case 'reminders':
			return <RemindersController />
		case 'management-opinions':
			return <ManagementOpinionController />
		default:
			return <NotesController />
	}
}

const PersonalAreaController = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)
	const qs = queryString.stringify(queryParams)
	const { user: sessionUser } = useSession()

	const tabs = [
		{
			id: '',
			text: i18n`Notes`,
		},
		{
			id: 'reminders',
			text: i18n`Reminders`,
		},
		{
			id: 'management-opinions',
			text: i18n`Management Opinions`,
		},
	]

	const [selectedTab, setSelectedTab] = useState(tabs[0].id)
	const isManagementOpinionsTab = selectedTab === 'management-opinions'

	const labels = {
		title: isManagementOpinionsTab
			? i18n`Management Opinions`
			: selectedTab.length
			? i18n`Reminders`
			: i18n`Notes`,
		lastUpdate: i18n`Last Update`,
	}

	const tasksContentUri = '/tasks/management_opinion'
	const notesContentUri = `/notes${qs ? `?${qs}` : ''}`
	const remindersContentUri = `/notes/reminders${qs ? `?${qs}` : ''}`
	const todayRemindersUri = `/notes/today_reminders${
		queryParams?.claimsManagerTrust
			? `?claimsManagerTrust=${sessionUser.legacyId}`
			: ''
	}`

	const managementOpinionContentUri = `/medical_opinions/management_opinions${
		qs ? `?${qs}` : ''
	}`

	const {
		state,
		contents,
		timestamps: [dataTimestamp],
		reload,
	} = useFetchList(
		[
			notesContentUri,
			remindersContentUri,
			todayRemindersUri,
			managementOpinionContentUri,
			tasksContentUri,
		],
		[
			Note.fromJSON,
			Note.fromJSON,
			Note.fromJSON,
			MedicalOpinion.fromJSON,
			Task.fromJSON,
		]
	)
	const isLoading = state === 'loading'
	const [
		notesContent,
		remindersContent,
		todayReminders,
		managementOpinionsContent,
		tasksContent,
	] = contents || []

	useEffect(() => {
		setQueryParams({
			claimsManagerTrust: 'user',
			date: undefined,
			sort: undefined,
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTab])

	return (
		<>
			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				<HStack
					className={styles['header-options']}
					align='center'
					justify='space-between'
					gap='xsmall'
					flex={[
						[1, 1],
						[1, 1],
					]}
				>
					<HStack gap='xsmall'>
						<div>
							<ActionButton
								icon='reload'
								className={styles['header-button']}
								onClick={() => {
									!isLoading && reload()
								}}
							/>
						</div>
						<VStack>
							<small>
								<strong>{labels.title}</strong>
							</small>
							<small className='ellipsis'>
								{labels.lastUpdate}:{' '}
								{<LastUpdate value={dataTimestamp} />}
							</small>
						</VStack>
					</HStack>
					<SegmentedControl
						className={styles['notes-segment-control']}
						selectedTab={selectedTab}
						onSelect={(e) => {
							setSelectedTab(e.id)
						}}
						tabs={tabs}
					/>
				</HStack>
			</Widget>

			<PersonalAreaContext.Provider
				value={{
					selectedTab: selectedTab,
					isLoading: isLoading,
					notes: {
						notesContentUri,
						notesContent,
					},
					reminders: {
						remindersContentUri,
						todayRemindersUri,
						remindersContent,
						todayReminders,
					},
					managementOpinions: {
						managementOpinionContentUri,
						managementOpinionsContent,
						tasksContent,
					},
				}}
			>
				{SelectedController(selectedTab)}
			</PersonalAreaContext.Provider>
		</>
	)
}

export default PersonalAreaController
